import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { map } from "lodash";
import {
  fetchEmployeeCampaigns,
  fetchEmployeeDesignations,
  fetchEmployeeOffices,
} from "actions";
import {
  EMPTY_SETUP_FILTERS,
  SETUP_STATUS_OPTIONS,
} from "../../utils/setupListQuery";

export { EMPTY_SETUP_FILTERS } from "../../utils/setupListQuery";

const toFilterOption = (option) =>
  option ? { value: option.value, label: option.label } : null;

const Filter = ({
  filters = EMPTY_SETUP_FILTERS,
  onFiltersChange,
  loadFilterOptions = false,
}) => {
  const dispatch = useDispatch();
  const employeeState = useSelector((state) => state.employeeState);

  const [show, setShow] = useState(false);
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  const [officeOptions, setOfficeOptions] = useState([]);

  const selectedCampaign = filters?.campaign || null;
  const selectedDesignation = filters?.designation || null;
  const selectedOffice = filters?.office || null;
  const selectedStatus = filters?.status || null;

  useEffect(() => {
    if (employeeState.campaignsList?.length > 0) {
      setCampaignOptions(
        map(employeeState.campaignsList, (campaign) => ({
          value: campaign.id,
          label:
            campaign.name ||
            campaign.client_name ||
            campaign.campaign_name ||
            "",
        }))
      );
    }
  }, [employeeState.campaignsList]);

  useEffect(() => {
    if (employeeState.designationsList?.length > 0) {
      setDesignationOptions(
        map(employeeState.designationsList, (designation) => ({
          value: designation.id,
          label: designation.name || designation.designation_name || "",
        }))
      );
    }
  }, [employeeState.designationsList]);

  useEffect(() => {
    if (employeeState.officesList?.length > 0) {
      setOfficeOptions(
        map(employeeState.officesList, (office) => ({
          value: office.id,
          label: office.name || office.office_name || "",
        }))
      );
    }
  }, [employeeState.officesList]);

  const ensureFilterOptionsLoaded = () => {
    if (!(employeeState.campaignsList || []).length && !employeeState.isCampaignsLoading) {
      dispatch(fetchEmployeeCampaigns());
    }
    if (
      !(employeeState.designationsList || []).length &&
      !employeeState.isDesignationsLoading
    ) {
      dispatch(fetchEmployeeDesignations());
    }
    if (!(employeeState.officesList || []).length && !employeeState.isOfficesLoading) {
      dispatch(fetchEmployeeOffices());
    }
  };

  useEffect(() => {
    if (!loadFilterOptions) return;
    ensureFilterOptionsLoaded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadFilterOptions]);

  const handleToggle = (isOpen) => {
    if (isOpen) {
      ensureFilterOptionsLoaded();
    }
    setShow(isOpen);
  };

  const updateFilter = (key, option) => {
    if (!onFiltersChange) return;
    onFiltersChange({
      ...filters,
      [key]: toFilterOption(option),
    });
  };

  const handleClear = () => {
    if (!onFiltersChange) return;
    onFiltersChange({ ...EMPTY_SETUP_FILTERS });
  };

  return (
    <Dropdown
      show={show}
      onToggle={handleToggle}
      align="end"
      className="filters-dropdown"
    >
      <Dropdown.Toggle
        variant="light"
        className="d-flex align-items-center gap-2"
      >
        <img src="/assets/images/filter-icon.svg" alt="" /> Filters
      </Dropdown.Toggle>

      <Dropdown.Menu className="p-4" style={{ minWidth: "640px" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="m-0 font-20">Filters</h5>
          <button
            type="button"
            className="text-success p-0 border-0 bg-transparent"
            onClick={handleClear}
          >
            Clear
          </button>
        </div>

        <hr />

        <Form>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Label className="label-input">Campaign</Form.Label>
              <Select
                placeholder="Campaign"
                className="multi-select w-100"
                classNamePrefix="react-select"
                isSearchable
                isClearable
                isLoading={employeeState.isCampaignsLoading}
                options={campaignOptions}
                value={selectedCampaign}
                onChange={(option) => updateFilter("campaign", option)}
              />
            </Col>
            <Col md={6}>
              <Form.Label className="label-input">Designation</Form.Label>
              <Select
                placeholder="Designation"
                className="multi-select w-100"
                classNamePrefix="react-select"
                isSearchable
                isClearable
                isLoading={employeeState.isDesignationsLoading}
                options={designationOptions}
                value={selectedDesignation}
                onChange={(option) => updateFilter("designation", option)}
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Label className="label-input">Office</Form.Label>
              <Select
                placeholder="Office"
                className="multi-select w-100"
                classNamePrefix="react-select"
                isSearchable
                isClearable
                isLoading={employeeState.isOfficesLoading}
                options={officeOptions}
                value={selectedOffice}
                onChange={(option) => updateFilter("office", option)}
              />
            </Col>
            <Col md={6}>
              <Form.Label className="label-input">Status</Form.Label>
              <Select
                placeholder="Status"
                className="multi-select w-100"
                classNamePrefix="react-select"
                isSearchable={false}
                isClearable
                options={SETUP_STATUS_OPTIONS}
                value={selectedStatus}
                onChange={(option) => updateFilter("status", option)}
              />
            </Col>
          </Row>
        </Form>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Filter;
